import {
  upgradeAccessLoading,
  upgradeAccessSuccess,
  upgradeAccessFailure,
  viewUsersLoading,
  viewUsersSuccess,
  viewUsersFailure,
  getOutstandingAmountLoading,
  getOutstandingAmountSuccess,
  getOutstandingAmountFailure,
  getPaymentHistoryLoading,
  getPaymentHistorySuccess,
  getPaymentHistoryFailure,
  getCustomOutstandingPaymentLoading,
  getCustomOutstandingPaymentSuccess,
  getCustomOutstandingPaymentFailure,
  getPostPayBillLoading,
  getPostPayBillSuccess,
  getPostPayBillFailure,
  postBillPaymentLoading,
  postBillPaymentSuccess,
  postBillPaymentFailure,
  } from "@redux/slices/postPaySlice";
import { upgradeDoctorAccess } from "@services/postPay/upgradeAccess";
import { viewUsers } from "@services/postPay/viewUsers";
import { postBillPayment } from "@services/postPay/postBillPayment";
import { getPostPayBill } from "@services/postPay/getPostPayBill";
import { getPostPayHistory } from "@services/postPay/getPaymentHistory";
import { getOutstandingAmount } from "@services/postPay/getOutstandingAmount";
import { getCustomOutstandingPayment } from "@services/postPay/getCustomOutstandingPayment";
import { useDispatch } from "react-redux";
import getErrorStatement from "src/utils/getErrorStatement";
import { notify } from "src/utils/notify";

const usePostPay = () => {
  const dispatch = useDispatch();
  
  const handleViewUsers = async (searchFilters) => {
    try {
      dispatch(viewUsersLoading());
      const response = await viewUsers(searchFilters);
      dispatch(viewUsersSuccess(response.data));
    } catch (error) {
      dispatch(viewUsersFailure());
      notify(getErrorStatement(error));
    }
  };
    
  const handleUpgradeAccess = async (updatedData) => {
    try {
      dispatch(upgradeAccessLoading());
      const response = await upgradeDoctorAccess(updatedData);
      dispatch(upgradeAccessSuccess(response.data));
      notify("Doctor details updated successfully", "success");
      // handleGetDoctorById(updatedData?.local?.doctorId);
    } catch (error) {
      dispatch(upgradeAccessFailure());
      notify(getErrorStatement(error));
    }
  };

  const handleOutstandingAmount = async (doctorId) => {
    try {
      dispatch(getOutstandingAmountLoading());
      const response = await getOutstandingAmount(doctorId);
      dispatch(getOutstandingAmountSuccess(response.data));
    } catch (error) {
      dispatch(getOutstandingAmountFailure());
      notify(getErrorStatement(error));
    }
  };

  const handleCustomOutstandingPayment = async (data) => {
    try {
      dispatch(getCustomOutstandingPaymentLoading());
      const response = await getCustomOutstandingPayment(data);
      dispatch(getCustomOutstandingPaymentSuccess(response.data));
    } catch (error) {
      dispatch(getCustomOutstandingPaymentFailure());
      notify(getErrorStatement(error));
    }
  };

  const handlePostPayBill = async (payload) => {
    try {
      dispatch(getPostPayBillLoading());
      const response = await getPostPayBill(payload);
      dispatch(getPostPayBillSuccess(response.data));
    } catch (error) {
      dispatch(getPostPayBillFailure());
      notify(getErrorStatement(error));
    }
  };

  const handlePostBillPayment = async (data) => {
    try {
      dispatch(postBillPaymentLoading());
      const response = await postBillPayment(data);
      dispatch(postBillPaymentSuccess(response.data));
    } catch (error) {
      dispatch(postBillPaymentFailure());
      notify(getErrorStatement(error));
    }
  };

  const handlePaymentHistory = async (historyData) => {
    try {
      dispatch(getPaymentHistoryLoading());
      const response = await getPostPayHistory(historyData);
      dispatch(getPaymentHistorySuccess(response.data));
    } catch (error) {
      dispatch(getPaymentHistoryFailure());
      notify(getErrorStatement(error));
    }
  };
  
  return {
    handleUpgradeAccess,
    handleViewUsers,
    handlePaymentHistory,
    handlePostPayBill,
    handlePostBillPayment,
    handleOutstandingAmount,
    handleCustomOutstandingPayment,
  };
};
  
export default usePostPay;
  